module.exports = __webpack_public_path__ + "aa0f8cd617fde6d835c703066e9f0fe8.png";